/*
* Lookup date of registration
*
* example:
* <element
*   data-interaction="LookupDateOfRegistration"
*   data-lookup-url="url_of_lookup_webservice"
*   date-lookup-type="method_of_lookup_webservice">
*
* */
class LookupDateOfRegistration {
    constructor(element, options) {
        this.form = element.parentNode;
        this.formContainer = element;
        this.formFields = this.formContainer.querySelectorAll(
            "[data-dateofregistration]"
        );
        this.options = options;
        this.requestUrl = this.options.lookupUrl;
        this.requestMethod = this.options.lookupType;
        this.resultPanel = this.formContainer.querySelector(".result");
        this.reasonCrediting = this.formContainer.querySelector(
            '[data-dateofregistration="reason_crediting"]'
        );
        this.dateBirth = this.formContainer.querySelector(
            '[data-dateofregistration="date_birth"]'
        );
        this.dateAbroad = this.formContainer.querySelector(
            '[data-dateofregistration="date_abroad"]'
        );
        this.zzcsrfToken = this.form.querySelector("[name=ZZCSRFToken]");

        this.init();
    }

    init() {
        Array.from(this.formFields).forEach(field => {
            field.addEventListener("change", this.update.bind(this));
        });
    }

    update() {
        // Check if values exist
        if (!this.checkValues()) return;

        let formData = `redenBijschrijving=${
            this.reasonCrediting.value
        }&geboortedatum=${this.dateBirth.value}&buitenlandDatum=${
            this.dateAbroad.value
        }&ZZCSRFToken=${this.zzcsrfToken.value}`;

        const method = this.requestMethod || "GET";

        let fetchProps = {
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8"
            },
            method,
            mode: "cors"
        };

        formData = formData.toString().replace(/gezinsleden\%5B\d\%5D\./gm, "");

        method === "POST" && (fetchProps.body = formData);

        this.showLoading();

        fetch(this.requestUrl, fetchProps)
            .then(response => response.json())
            .then(this.updateResultPanel.bind(this))
            .catch(error => {
                this.hideLoading();
                console.error(error);
            });
    }

    checkValues() {
        return this.reasonCrediting.value !== "" && this.dateBirth.value !== "";
    }

    updateResultPanel(data) {
        this.resultPanel.innerHTML = data.date;
        this.hideLoading();
        this.showResultPanel();
    }

    hideResultPanel() {
        this.resultPanel.style.display = "none";
    }

    showResultPanel() {
        this.resultPanel.style.display = "inline-block";
    }

    showLoading() {
        this.resultPanel.classList.add("loader");
    }

    hideLoading() {
        this.resultPanel.classList.remove("loader");
    }
}
